const WEBHOOK_URL = 'https://hook.us2.make.com/abvi5ettdl7cn1gk15w1bzgsa74582e8';

export interface WebhookSubscribePayload {
  email: string;
  name?: string;
  source: string;
  page_url: string;
  article_title?: string;
}

export async function sendSubscribeWebhook(payload: WebhookSubscribePayload): Promise<void> {
  try {
    await fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: payload.email,
        name: payload.name ?? '',
        source: payload.source,
        page_url: payload.page_url,
        article_title: payload.article_title ?? '',
      }),
    });
  } catch {
    // Fail silently — webhook is secondary to local submission
  }
}
